import { Component, input, output } from '@angular/core';
import { Button } from 'primeng/button';
import { Guid } from 'guid-typescript';
import { Tooltip } from 'primeng/tooltip';

export enum ButtonSeverity {
  PRIMARY = 'primary',
  OUTLINE = 'outline',
  SECONDARY = 'secondary',
  TERTIARY = 'tertiary',
  SUCCESS = 'success',
  LINK = 'link',
}

export enum ButtonSize {
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
}

@Component({
  selector: 'app-button',
  standalone: true,
  imports: [Button, Tooltip],
  templateUrl: './button.html',
  styleUrl: './button.scss',
})
export class ButtonComponent {
  btnLabel = input<string>('');
  btnClass = input<string>('');
  isBtnDisabled = input<boolean>(false);
  isDestructive = input<boolean>(false);
  btnId = input<string>(`vhz-btn-${Guid.create()}`);
  btnType = input<string>('button');
  btnSize = input<ButtonSize>(ButtonSize.SM);
  btnTooltip = input<string>('');
  btnTooltipPosition = input<'right' | 'left' | 'top' | 'bottom'>('top');
  btnSeverity = input<string>(ButtonSeverity.PRIMARY);

  btnClicked = output<MouseEvent>();

  /**
   * PrimeNG's pAutoFocus sets the native `autofocus` attribute unless it resolves to exactly `false`
   * (`autofocus || buttonProps?.autofocus`), which focused the first button on page load.
   */
  protected readonly buttonProps = { autofocus: false };

  handleBtnClick(event: MouseEvent) {
    this.btnClicked.emit(event);
  }
}
